/** Calendar day as `YYYY-MM-DD`, never a `Date` object. */
export type IsoDate = string;

export enum DashboardPeriod {
  MTD = 'MTD',
  QTD = 'QTD',
  YTD = 'YTD',
  CUSTOM = 'CUSTOM',
}

export enum DashboardScope {
  MY_DEALS = 'MY_DEALS',
  WHOLE_TEAM = 'WHOLE_TEAM',
}

/** Wire value of the `scope` query parameter shared by every dashboard endpoint; `DashboardScope` maps onto it. */
export enum DashboardWireScope {
  MY = 'my',
  TEAM = 'team',
}

/** Half-open wire range: `from` inclusive, `to` exclusive (the bar's inclusive `to` + 1 day), Eastern calendar dates. */
export interface DashboardPeriodRequest {
  from: IsoDate;
  to: IsoDate;
  scope: DashboardWireScope;
}

/** Echo of the validated request; `to` is exclusive. */
export interface DashboardPeriodEcho {
  from: IsoDate;
  to: IsoDate;
}

export interface DashboardFilters {
  period: DashboardPeriod;
  scope: DashboardScope;
  customFrom: IsoDate | null;
  customTo: IsoDate | null;
}

/**
 * `to` is the inclusive last calendar day shown in the label; the API wire format is half-open,
 * so a remote sends `to + 1 day`.
 */
export interface DashboardDateRange {
  from: IsoDate;
  to: IsoDate;
}

export const DEFAULT_DASHBOARD_FILTERS: DashboardFilters = {
  period: DashboardPeriod.MTD,
  scope: DashboardScope.MY_DEALS,
  customFrom: null,
  customTo: null,
};
